import { optionTitle_pbp } from './strings.locstring.json';
import { optionTitle_pbpMeetingDetails } from './ComposeServicePbpOption.locstring.json';
import { isFeatureEnabled } from 'owa-feature-flags';
import getShownView from 'owa-pbp-option/lib/selectors/getShownView';
import PersonalBookingPageShownView from './data/store/schema/PersonalBookingPageShownView';
import getAnonymousSharingStatus from 'owa-pbp-option-publishing-settings/lib/selectors/getAnonymousSharingStatus';

import { LazyOption, createLazyOption } from 'owa-options-core';
import { LazyModule } from 'owa-bundling';
var lazyFullModule = new LazyModule(() => import('./lazyFullComposeServicePbpOption'));
let ComposeServicePbpOption: LazyOption = createLazyOption(
    {
        key: 'composePbpServiceOption',
        titleStringKey: optionTitle_pbpMeetingDetails,
        searchTermsStringKey: optionTitle_pbp,
        isHidden: () => {
            return (
                !isFeatureEnabled('cal-personalbookingpage') ||
                getShownView() != PersonalBookingPageShownView.EditService ||
                !getAnonymousSharingStatus()
            );
        },
    },
    lazyFullModule,
    m => m.default
);
export default ComposeServicePbpOption;
